import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

export default function RouteErrorFallback() {
    const error = useRouteError();
    const message = isRouteErrorResponse(error)
        ? error.statusText || 'Something went wrong'
        : error instanceof Error
          ? error.message
          : 'Something went wrong';

    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
            <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
            <p className="mb-6 text-(--gray-11)">{message}</p>
            <Link
                to="/"
                className="text-(--accent-11) underline"
            >
                Go to home
            </Link>
        </div>
    );
}
